import { useInkind } from '@gik/api/inkinds/inkind';
import { useInkindCan } from '@gik/core/store/permissions';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui/Button';
import type { ProportionSetting } from '@gik/ui/KeepProportions';
import { KeepProportions } from '@gik/ui/KeepProportions';
import { Wishlist } from '@gik/ui/SvgIcon/GikIcons/Wishlist';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import WishlistIcon from '@gik/wishlist-page/assets/icon-wishlist.svg';
import PlusIcon from '@heroicons/react/outline/PlusIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface IWishlistEmptyStateProps {
  inkindRouteId: string;
  proportion?: ProportionSetting;
}

function WishlistEmptyStateComp({ inkindRouteId, proportion }: IWishlistEmptyStateProps) {
  const userStore = useUserStore();
  const userId = userStore.id;

  const { data: inkindPage } = useInkind(inkindRouteId);
  const canEdit = useInkindCan('manage', inkindRouteId, inkindPage?.groupId);
  const bem = bemBlock('wishlist-empty');
  const { t } = useTranslation();

  return (
    <KeepProportions proportion={proportion}>
      <div className={bem()}>
        <WishlistIcon />
        <span className={`${bem('title')}`}>{t(translationKeys.empty).toString()}</span>
        {canEdit && (
          <>
            <p>
              Add to your wishlist by
              <br /> clicking the “<SvgIcon className={`${bem('plus-icon')}`} size="xl" Icon={PlusIcon} />“ on items
            </p>

            <Button
              type={'a'}
              href={inkindPage?.inkindSituations?.[0]?.giftingUrl}
              variant="secondary"
              prepend={<SvgIcon size="lg" Icon={Wishlist} />}
            >
              {t(translationKeys.findWishlistIdeas).toString()}
            </Button>
          </>
        )}
      </div>
    </KeepProportions>
  );
}

export const WishlistEmptyState = withComponentErrorBoundary(WishlistEmptyStateComp);
